import { useState } from 'react';

import { FormattedMessage } from 'react-intl';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Commit as CommitType, RenderedContent } from 'src/components/types';

import Button from '@atlaskit/button/new';
import RenderedTitle from '@atlassian/bitbucket-rendered-title';

import messages from '../i18n';
import * as styles from '../styles';

export const DefaultCommitMessage = ({
  commit,
  renderedMessage,
  isCommitExpandEnabled,
}: {
  commit: CommitType;
  renderedMessage: RenderedContent;
  isCommitExpandEnabled: boolean;
}): JSX.Element => {
  const [expanded, setExpanded] = useState(false);

  // Feature flag isn't turned on, render the old default commit message
  if (!isCommitExpandEnabled) {
    return (
      <styles.CommitMessage title={renderedMessage.raw}>
        <RenderedTitle fadeLinesAfterFirst renderedContent={renderedMessage} />
      </styles.CommitMessage>
    );
  }
  // Otherwise continue with all the new logic

  if (((commit.message && commit.message.match(/\n/g)) || []).length < 2) {
    return (
      <styles.CommitMessage>
        <RenderedTitle fadeLinesAfterFirst renderedContent={renderedMessage} />
      </styles.CommitMessage>
    );
  } else {
    return (
      <>
        <styles.CommitMessage>
          {expanded ? (
            <styles.ExpandedCommitMessage>
              <RenderedTitle renderedContent={renderedMessage} />
            </styles.ExpandedCommitMessage>
          ) : (
            <RenderedTitle
              fadeLinesAfterFirst
              renderedContent={renderedMessage}
            />
          )}
        </styles.CommitMessage>
        {!expanded && (
          <Button
            onClick={() => setExpanded(true)}
            spacing="compact"
            appearance="subtle"
          >
            <FormattedMessage {...messages.expandCommitButton}>
              {text => text}
            </FormattedMessage>
          </Button>
        )}
      </>
    );
  }
};
